/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const TablePaginationKey = {
  CaCases: 'caCases',
  CaUsers: 'caUsers',
  CaPatientSelect: 'caPatientSelect',
  CollectorCases: 'collectorCases',
  CollectorUsers: 'collectorUsers',
  ProviderAppointments: 'providerAppointments',
  SuperAdminCases: 'superAdminCases',
  SuperAdminClients: 'superAdminClients',
  SuperAdminUserSearch: 'superAdminUserSearch',
  SuperAdminAuditTrail: 'superAdminAuditTrail',
  SuperAdminPatientSelect: 'superAdminPatientSelect',
  CaseActivity: 'caseActivity',
} as const;

export type TablePaginationKeyType = (typeof TablePaginationKey)[keyof typeof TablePaginationKey];

export type TablePaginationState = Partial<Record<TablePaginationKeyType, number>>;

const initialState: TablePaginationState = {};

const tablePaginationSlice = createSlice({
  name: 'tablePagination',
  initialState,
  reducers: {
    setRowsPerPage: (
      state,
      action: PayloadAction<{ tableKey: TablePaginationKeyType; rowsPerPage: number }>,
    ) => {
      state[action.payload.tableKey] = action.payload.rowsPerPage;
    },
    clearRowsPerPage: (state, action: PayloadAction<TablePaginationKeyType>) => {
      delete state[action.payload];
    },
  },
});

export const { setRowsPerPage, clearRowsPerPage } = tablePaginationSlice.actions;

export default tablePaginationSlice.reducer;
